import { render, staticRenderFns } from "./CustomCard.vue?vue&type=template&id=40a53c8e&scoped=true&"
var script = {}
import style0 from "./CustomCard.vue?vue&type=style&index=0&id=40a53c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a53c8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
